/* tslint:disable */
/* eslint-disable */
/**
 * Knowspread API v1
 *  This document describes API of education system Knowspread. This API is used by AngularJS web application. ##Api path Api lives on path `./api/v1/{resource}` relative to the root of the deployed application. ##Api versioning This api is versioned to allow further updates that would break backward compatibility. Current version is `v1` and it will be finalized when the App is deployed into production. In every response with status code `2xx`, `400`, `401` or `403` is returned `X-API-Version` header with current api version. This value is for checking correct api version used in Android or iOS application. ## Request and Response format Both response and request bodies are of type `application/json` if not noted otherwise.  ## Authentication Client accessing Knowspread application authenticates itself with a `POST` request against endpoint `./api/v1/users/login` through invitation link or with username and password. If the user authentication is successful an user unique identificator `uid` is returned together with an `access-token`, `client` - type of client, which allows to be authenticated on more devices, and information about access token expiration. (Please see corresponding API spec for concrete JSON format of request and response)  Each API call of given client is then authenticated using the returned `access-token`,`client` and `uid` which is passed to the server in header. Server returns `401 - Unauthorized` if the given token is expired or not valid. In case of invalid token, client can request a new one by authenticating against `./api/v1/users/login` again. AccessToken validity is automatically prolonged by using it.  ## Error States  The common [HTTP Response Status Codes](https://github.com/for-GET/know-your-http-well/blob/master/status-codes.md) are used for signaling error states.  Error status codes are specified in first endpoint in API spec - `./api/v1/`.  ##Success code `200` status code is returned on success (it does not matter if it is a Create,Read,Delete or Update operation) ## Common patterns in KnowSpread API  All REST based resources in this follow these rules:  * CREATE (`POST`) - Returns status code `201 (OK)` when the creation of entity is successful. and contains dictionary representing the created entity, * READ (`GET`) - Returns status code `200 (OK)` and dictionary or array of dictionaries representing the entity requested. Dictionary with the same keys is expected by the server when updating the entity. * UPDATE (`PUT`) - Returns status code `200 (OK)` and dictionary that represents state of the entity after modification. * DELETE (`DELETE`) - Returns status code `204 (OK)` upon successful deletion of entity.  ## Date formatting API accepts and returns dates in ISO_8601. For more info see: http://en.wikipedia.org/wiki/ISO_8601 ## Documentation tags * PAGEABLE - this marks this request as pageable. If you want to iterate over pages, set query `\'page\' (integer)` to number requested page. You can set query `\'paginates_per\' (integer)`, what sets records count on one page. This request returns count of total pages, current page and total records count in header. * JOB PROCESSING always - where job scheduled always * JOB PROCESSING sometimes - where job scheduled sometimes * JOB PROCESSING callbacks - where shceduled any jobs to support main action of endpoint e.g. assign content to all users in group etc. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContentParticipationCompanySpace } from './ContentParticipationCompanySpace';
import {
    ContentParticipationCompanySpaceFromJSON,
    ContentParticipationCompanySpaceFromJSONTyped,
    ContentParticipationCompanySpaceToJSON,
} from './ContentParticipationCompanySpace';
import type { ContentParticipationLesson } from './ContentParticipationLesson';
import {
    ContentParticipationLessonFromJSON,
    ContentParticipationLessonFromJSONTyped,
    ContentParticipationLessonToJSON,
} from './ContentParticipationLesson';
import type { ContentParticipationReassignResponseContentVersion } from './ContentParticipationReassignResponseContentVersion';
import {
    ContentParticipationReassignResponseContentVersionFromJSON,
    ContentParticipationReassignResponseContentVersionFromJSONTyped,
    ContentParticipationReassignResponseContentVersionToJSON,
} from './ContentParticipationReassignResponseContentVersion';
import type { ContentParticipationReassignResponseRelatedContentParticipationsInner } from './ContentParticipationReassignResponseRelatedContentParticipationsInner';
import {
    ContentParticipationReassignResponseRelatedContentParticipationsInnerFromJSON,
    ContentParticipationReassignResponseRelatedContentParticipationsInnerFromJSONTyped,
    ContentParticipationReassignResponseRelatedContentParticipationsInnerToJSON,
} from './ContentParticipationReassignResponseRelatedContentParticipationsInner';
import type { ContentParticipationReassignResponseUserGroupsInner } from './ContentParticipationReassignResponseUserGroupsInner';
import {
    ContentParticipationReassignResponseUserGroupsInnerFromJSON,
    ContentParticipationReassignResponseUserGroupsInnerFromJSONTyped,
    ContentParticipationReassignResponseUserGroupsInnerToJSON,
} from './ContentParticipationReassignResponseUserGroupsInner';
import type { ContentParticipationStep } from './ContentParticipationStep';
import {
    ContentParticipationStepFromJSON,
    ContentParticipationStepFromJSONTyped,
    ContentParticipationStepToJSON,
} from './ContentParticipationStep';

/**
 * Reassigns content participation for given user to a new deadline. Pass content_participation_id as :id. Required param :deadline must be before the currently set deadline otherwise error will be raised. Pass as either Date format e.g. "2025-08-28" or DateTime format e.g. "2025-08-28 11:36:17". Returned result is new content_participation Example API call "/api/v1/company_spaces/1/users/1/content/1/reassign", deadline: 2025-08-28
 * @export
 * @interface ContentParticipationReassignResponse
 */
export interface ContentParticipationReassignResponse {
    /**
     * 
     * @type {number}
     * @memberof ContentParticipationReassignResponse
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof ContentParticipationReassignResponse
     */
    content_participation_id: number;
    /**
     * 
     * @type {string}
     * @memberof ContentParticipationReassignResponse
     */
    state: string;
    /**
     * 
     * @type {number}
     * @memberof ContentParticipationReassignResponse
     */
    percent_done: number;
    /**
     * 
     * @type {number}
     * @memberof ContentParticipationReassignResponse
     */
    time_estimation: number;
    /**
     * 
     * @type {number}
     * @memberof ContentParticipationReassignResponse
     */
    user_id: number;
    /**
     * 
     * @type {Date}
     * @memberof ContentParticipationReassignResponse
     */
    nearest_deadline: Date;
    /**
     * 
     * @type {Date}
     * @memberof ContentParticipationReassignResponse
     */
    created_at: Date;
    /**
     * 
     * @type {string}
     * @memberof ContentParticipationReassignResponse
     */
    completed_at: string;
    /**
     * 
     * @type {Date}
     * @memberof ContentParticipationReassignResponse
     */
    last_studied_at: Date;
    /**
     * 
     * @type {string}
     * @memberof ContentParticipationReassignResponse
     */
    lock_reason: string;
    /**
     * 
     * @type {string}
     * @memberof ContentParticipationReassignResponse
     */
    confirmed_at?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ContentParticipationReassignResponse
     */
    certificate_available: boolean;
    /**
     * 
     * @type {ContentParticipationReassignResponseContentVersion}
     * @memberof ContentParticipationReassignResponse
     */
    content_version?: ContentParticipationReassignResponseContentVersion;
    /**
     * 
     * @type {Array<ContentParticipationCompanySpace>}
     * @memberof ContentParticipationReassignResponse
     */
    company_spaces?: Array<ContentParticipationCompanySpace>;
    /**
     * 
     * @type {ContentParticipationLesson}
     * @memberof ContentParticipationReassignResponse
     */
    current_lesson?: ContentParticipationLesson;
    /**
     * 
     * @type {ContentParticipationStep}
     * @memberof ContentParticipationReassignResponse
     */
    current_step?: ContentParticipationStep;
    /**
     * 
     * @type {Array<ContentParticipationReassignResponseUserGroupsInner>}
     * @memberof ContentParticipationReassignResponse
     */
    user_groups?: Array<ContentParticipationReassignResponseUserGroupsInner>;
    /**
     * 
     * @type {Array<ContentParticipationReassignResponseRelatedContentParticipationsInner>}
     * @memberof ContentParticipationReassignResponse
     */
    related_content_participations?: Array<ContentParticipationReassignResponseRelatedContentParticipationsInner>;
}

/**
 * Check if a given object implements the ContentParticipationReassignResponse interface.
 */
export function instanceOfContentParticipationReassignResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "content_participation_id" in value;
    isInstance = isInstance && "state" in value;
    isInstance = isInstance && "percent_done" in value;
    isInstance = isInstance && "time_estimation" in value;
    isInstance = isInstance && "user_id" in value;
    isInstance = isInstance && "nearest_deadline" in value;
    isInstance = isInstance && "created_at" in value;
    isInstance = isInstance && "completed_at" in value;
    isInstance = isInstance && "last_studied_at" in value;
    isInstance = isInstance && "lock_reason" in value;
    isInstance = isInstance && "certificate_available" in value;

    return isInstance;
}

export function ContentParticipationReassignResponseFromJSON(json: any): ContentParticipationReassignResponse {
    return ContentParticipationReassignResponseFromJSONTyped(json, false);
}

export function ContentParticipationReassignResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContentParticipationReassignResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'content_participation_id': json['content_participation_id'],
        'state': json['state'],
        'percent_done': json['percent_done'],
        'time_estimation': json['time_estimation'],
        'user_id': json['user_id'],
        'nearest_deadline': (new Date(json['nearest_deadline'])),
        'created_at': (new Date(json['created_at'])),
        'completed_at': json['completed_at'],
        'last_studied_at': (new Date(json['last_studied_at'])),
        'lock_reason': json['lock_reason'],
        'confirmed_at': !exists(json, 'confirmed_at') ? undefined : json['confirmed_at'],
        'certificate_available': json['certificate_available'],
        'content_version': !exists(json, 'content_version') ? undefined : ContentParticipationReassignResponseContentVersionFromJSON(json['content_version']),
        'company_spaces': !exists(json, 'company_spaces') ? undefined : ((json['company_spaces'] as Array<any>).map(ContentParticipationCompanySpaceFromJSON)),
        'current_lesson': !exists(json, 'current_lesson') ? undefined : ContentParticipationLessonFromJSON(json['current_lesson']),
        'current_step': !exists(json, 'current_step') ? undefined : ContentParticipationStepFromJSON(json['current_step']),
        'user_groups': !exists(json, 'user_groups') ? undefined : ((json['user_groups'] as Array<any>).map(ContentParticipationReassignResponseUserGroupsInnerFromJSON)),
        'related_content_participations': !exists(json, 'related_content_participations') ? undefined : ((json['related_content_participations'] as Array<any>).map(ContentParticipationReassignResponseRelatedContentParticipationsInnerFromJSON)),
    };
}

export function ContentParticipationReassignResponseToJSON(value?: ContentParticipationReassignResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'content_participation_id': value.content_participation_id,
        'state': value.state,
        'percent_done': value.percent_done,
        'time_estimation': value.time_estimation,
        'user_id': value.user_id,
        'nearest_deadline': (value.nearest_deadline.toISOString()),
        'created_at': (value.created_at.toISOString()),
        'completed_at': value.completed_at,
        'last_studied_at': (value.last_studied_at.toISOString()),
        'lock_reason': value.lock_reason,
        'confirmed_at': value.confirmed_at,
        'certificate_available': value.certificate_available,
        'content_version': ContentParticipationReassignResponseContentVersionToJSON(value.content_version),
        'company_spaces': value.company_spaces === undefined ? undefined : ((value.company_spaces as Array<any>).map(ContentParticipationCompanySpaceToJSON)),
        'current_lesson': ContentParticipationLessonToJSON(value.current_lesson),
        'current_step': ContentParticipationStepToJSON(value.current_step),
        'user_groups': value.user_groups === undefined ? undefined : ((value.user_groups as Array<any>).map(ContentParticipationReassignResponseUserGroupsInnerToJSON)),
        'related_content_participations': value.related_content_participations === undefined ? undefined : ((value.related_content_participations as Array<any>).map(ContentParticipationReassignResponseRelatedContentParticipationsInnerToJSON)),
    };
}

